import { InboxFile } from '../../types/index';
import { Inference } from '../../types';
import { DatasetFileVersion } from '../../types/dataset';
import { TestResult } from '../../types';

export const reformInboxFileToPdfFile = (inputFile: InboxFile) => {
  return {
    id: inputFile.id,
    fileId: inputFile.id,
    fileName: inputFile.id,
    presignedUrl: inputFile.presignedPdfUrl,
    presignedWordsUrl: inputFile.presignedPdfUrl,
    resultFields: inputFile.resultFields,
    originalType: 'InboxFile',
  };
};

export const reformInferenceToPdfFile = (inferenceFile: Inference) => {
  return {
    id: inferenceFile.id,
    fileId: inferenceFile.fileId,
    fileName: inferenceFile.fileName,
    presignedUrl: inferenceFile.presignedUrl,
    presignedWordsUrl: inferenceFile.presignedWordsUrl,
    resultFields: [],
    originalType: 'Inference',
  };
};

export const reformDatasetFileToPdfFile = (datasetFileVersion: DatasetFileVersion) => {
  return {
    id: datasetFileVersion.id,
    fileId: datasetFileVersion.datasetFile.file_id,
    fileName: datasetFileVersion.datasetFile.file_name,
    presignedUrl: datasetFileVersion.datasetFile.presignedUrl,
    presignedWordsUrl: datasetFileVersion.datasetFile.presignedWordsUrl,
    resultFields: [],
    originalType: 'DatasetFile',
  };
};

export const reformTestResultFileToPdfFile = (datasetFileVersion: DatasetFileVersion, testResult: TestResult) => {
  return {
    id: datasetFileVersion.datasetFile.file_id,
    fileId: datasetFileVersion.datasetFile.file_id,
    fileName: datasetFileVersion.datasetFile.file_name,
    presignedUrl: datasetFileVersion.datasetFile.presignedUrl,
    presignedWordsUrl: datasetFileVersion.datasetFile.presignedWordsUrl,
    resultFields: testResult.resultFields,
    originalType: 'TestResult',
  };
};
